// --- Utility Functions ---

/**
 * Convert string to Proper Case
 */
export const toProperCase = (str: string | null | undefined): string => {
  if (!str) return '';
  return str.toLowerCase().replace(/(?:^|\s)\w/g, match => match.toUpperCase());
};

/**
 * Format number as Indian currency format
 */
export const formatCurrency = (val: number): string => {
  return new Intl.NumberFormat('en-IN').format(val);
};

